import { Score, defaultScore } from './score';
import { SuccessStatus } from './success-status';
import { CompletionStatus } from '../../api';

export function defaultObjective(): Objective {
  return {
    id: '',
    score: defaultScore(),
    completionStatus: CompletionStatus.unknown,
    successStatus: SuccessStatus.unknown,
    progressMeasure: 0,
    description: ''
  };
}

export interface Objective {
  id: string;
  score: Score;
  completionStatus: CompletionStatus;
  successStatus: SuccessStatus;
  progressMeasure: number;
  description: string;
}
